import {IDotRezApiService} from "./dot-rez-api.service.interface";
import {ServiceBase} from "../service-base";
import {buildFullUrl, isHttpErrorStatusCode} from "../http/http-helpers";
import {DeeplinkAgentTokenRequest} from "../airline-webapi/requests/deeplink-agent-token.request";

export class DotRezApiService extends ServiceBase implements IDotRezApiService {

    buildDotRezUrl(path: string ) {
        if(!this.services.configuration.dotRezApiUrl) {
            throw new Error('dotRezApiUrl was not initialized');
        }
        return buildFullUrl(this.services.configuration.dotRezApiUrl, path);
    }

    async createAnonymousToken(): Promise<string> {
        let {token} = await this.services.airlineWebapi.createDotRezAnonymousToken();
        token = await this.services.crypto.decryptServerMessage(token);
        return token;
    }

    async getDeepLinkAgentToken(request: DeeplinkAgentTokenRequest): Promise<string> {
        let {dotRezToken} = await this.services.airlineWebapi.getDeepLinkAgentToken(request);
        dotRezToken = await this.services.crypto.decryptServerMessage(dotRezToken);
        return dotRezToken;
    }

    get tokenApiUrlForGET(): string {
        return '/api/nsk/v1/token';
    }


/*
    get tokenApiUrlForPUT(): string {
        if(this.services.configuration.data.dotRezMigrationEnabled) {
            return '/api/auth/v1/token/user';
        } else {
            return '/api/nsk/v1/token';
        }
    }
*/
    async tryRefreshToken(token: string): Promise<void> {
        const response = await fetch(this.buildDotRezUrl(this.tokenApiUrlForGET), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token,
                ...this.services.configuration.dotRezApiSubscriptionKeyHeader
            }
        });

        if(isHttpErrorStatusCode(response.status)) {
            throw new Error('Failed to refresh token');
        }
    }

    getDotRezApiRequestHeaders(token: string): Record<string, string> {
        return {
            'Content-Type': 'application/json',
            'Authorization': token,
            ...this.services.configuration.dotRezApiSubscriptionKeyHeader
        }
    }

}
